import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-176" data-mp="2pe7eu3w4nl5a">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-177" data-mp="2bfzls727p3ze">
        <h2 className="mx-auto max-w-3xl font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-ink md:text-5xl" data-id="element-178" data-mp="2bi29gkfw6l0y">
          ¿Cuántos meses más vas a perder buscando qué hacer?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-blue-900/75 md:text-xl" data-id="element-179" data-mp="26gmo0r9syci1">
          Amás a esta persona. Pero cada semana empieza de cero: buscás ejercicios, probás cosas
          sueltas y llegás al lunes sin saber si algo de eso sirvió.
        </p>
        <p className="mx-auto mt-6 font-display text-xl font-extrabold tracking-tight text-blue-600 md:text-2xl" data-id="element-180" data-mp="1wr37hs9kauqc">
          No es falta de amor. Es falta de un sistema.
        </p>

        <ul className="mx-auto mt-12 max-w-narrow space-y-3 text-left" data-id="element-181" data-mp="1nplr08s8sr14">
          {painPoints.map(point => <li key={point} className="flex items-center gap-4 rounded-2xl bg-alert-50 px-5 py-4 ring-1 ring-alert-100 md:px-6" data-id="element-182" data-mp="t83xfvml7vwy">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-alert-100 text-alert-600" data-id="element-183" data-mp="129k3jr6ddbvd">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-184" data-mp="xcbkzphb75tl" />
              </span>
              <span className="text-lg font-medium leading-snug text-ink" data-id="element-185" data-mp="9mqzozxonwh5">{point}</span>
            </li>)}
        </ul>

        <p className="mx-auto mt-14 max-w-2xl font-display text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-4xl" data-id="element-186" data-mp="5i9mxkpqqjfv">
          ¿Y si el próximo mes fuera diferente?
        </p>
      </div>
    </section>;
}